module.exports = __webpack_public_path__ + "img/intro.7aae6db0.jpg";